/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SearchRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      schools: this.store.findAll('school'),
    });
  }
}
